export default {
  props: {
    id: {
      type: Number,
      required: true,
    },
    name: {
      type: String,
      required: true,
    },
    selected: {
      type: Boolean,
      default: false,
    },
    theme: {
      type: String,
      default: 'sushi',
    },
  },
  data() {
    return {
      isSelected: this.selected,
    };
  },
  computed: {
    buttonModifier() {
      return {
        [`filter-button--${this.theme}`]: this.theme,
        'filter-button--selected': this.isSelected,
      };
    },
  },
  methods: {
    toggleFilter(e) {
      e.stopPropagation();
      this.isSelected = !this.isSelected;
      if (this.isSelected) {
        this.$emit('addFilter', this.id);
      } else {
        this.$emit('removeFilter', this.id);
      }
    },
  },
};
